import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var InstallService = /** @class */ (function () {
    function InstallService(ngZone, route, router) {
        this.ngZone = ngZone;
        this.route = route;
        this.router = router;
        this.visible = new BehaviorSubject(false);
        this.appInstalled = new BehaviorSubject(false);
    }
    InstallService.prototype.show = function () {
        this.visible.next(true);
        document.body.classList.add('is-hidden');
    };
    InstallService.prototype.hide = function () {
        this.visible.next(false);
        document.body.classList.remove('is-hidden');
    };
    InstallService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InstallService_Factory() { return new InstallService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i1.Router)); }, token: InstallService, providedIn: "root" });
    return InstallService;
}());
export { InstallService };
